/**
 * Generates initials from first and last names, handling emoji characters gracefully
 * @param firstName - The first name
 * @param lastName - The last name
 * @returns A string containing initials or a fallback character
 */
export const getInitials = (firstName: string, lastName: string): string => {
  const getFirstChar = (str: string): string => Array.from(str.trim())[0] || "";

  const firstChar = getFirstChar(firstName);
  const lastChar = getFirstChar(lastName);

  // If both names exist, return both first characters
  if (firstChar && lastChar) {
    return firstChar + lastChar;
  }

  // Fallback if no names
  return "";
};
